import React from 'react';
import PropTypes from 'prop-types';
import { useFormikContext } from 'formik';
import { get, isEmpty } from 'lodash';

import { useStyles } from '~/assets/styles';
import { SortIcon } from '~/components/icons';
import InlineIconButton from '~/components/InlineIconButton';
import { stringCmp } from '~/Utils';
import cn from '~/Utils/cn';

const SortAzButton = ({ fieldId, sortKey, disabled, sortIndexes }) => {
  const { classes } = useStyles();
  const { values, setFieldValue } = useFormikContext();
  const currentValue = get(values, fieldId);

  const compare = (a, b) => (isEmpty(a?.[sortKey]) ? 0 : stringCmp(a?.[sortKey], b?.[sortKey]));

  const onSortAz = (e) => {
    e.stopPropagation();
    if (!Array.isArray(currentValue)) return;

    // When sortIndexes is provided, sort only those entries among their own positions and leave
    // every other slot untouched — e.g. a section header that shares one array with another section.
    if (Array.isArray(sortIndexes)) {
      const sorted = sortIndexes.map((index) => currentValue[index]).sort(compare);
      const next = [...currentValue];
      sortIndexes.forEach((index, sortedIdx) => {
        next[index] = sorted[sortedIdx];
      });
      setFieldValue(fieldId, next);
      return;
    }

    setFieldValue(fieldId, [...currentValue].sort(compare));
  };

  return (
    <InlineIconButton
      icon={SortIcon}
      tooltipTitle="Sort A-Z"
      ariaLabel="Sort A-Z"
      iconStyle={{ display: 'flex', width: 24, height: 24 }}
      className={cn(classes.textIcon, classes.hoverableIcon)}
      onClick={onSortAz}
      disabled={disabled}
    />
  );
};

SortAzButton.propTypes = {
  fieldId: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  sortKey: PropTypes.string,
  // Optional subset of array indexes to sort among themselves; other positions stay put.
  sortIndexes: PropTypes.arrayOf(PropTypes.number),
};

export default SortAzButton;
